import React, { Component } from 'react';
import {
	Col,
	Label,
    Row,
    Input,
    Card,
    CardBody,
    Button,
    CardImg,
    CardTitle,
    CardText,
    Container
} from 'reactstrap';
import { data } from './data';
import defaultImg from "../../assets/images/product/prison.jpg";
import ProfileImageAdd from '../TestimonyManager/ProfileImageAdd';
import UploadFile from './UploadFile';
import UserStatus from './UserStatus';
import RegisterUser from './RegisterUser';

export default class SearchUser extends Component {
    constructor(props) {
		super(props);
        this.state = {
            success: false,
            error: false,
            message: "",
            searchTerm: "",
            data: data,
            filteredData: [],
            hoveringDataIndex: null
        }
    }

    stateHandling = (event) => {
		this.setState({
			[event.target.id]: event.target.value,
		});
        this.searchData();
        if (event.target.value === "") {
            this.setState({
                filteredData: []
            });
        }
	};

    setHoveringDataIndex = (index) => {
        this.setState({
            hoveringDataIndex: index
        });
    }

    searchData = () => {
        const { searchTerm, data } = this.state;
        const filteredData = data.filter((item) => {
            return item.firstname.toLowerCase().includes(searchTerm.toLowerCase()) || item.lastname.toLowerCase().includes(searchTerm.toLowerCase());
        });
        this.setState({
            filteredData: filteredData
        });
    }

    notify = (isSuccess) => {
        const message = isSuccess ? 'Successfully uploaded!' : 'Failed to upload!';
        this.setState({
            success: isSuccess ? true : false,
            error: isSuccess ? false : true,
            message: message
        });
        setTimeout(() => {
            this.setState({
                success: false,
                error: false,
                message: ""
            });
        }, 5000);
    }

    render() {
		return (
			<React.Fragment>
                <div className='page-content'>
                    <Row>
                        <Col md={12} className='d-flex justify-content-center'>
                        <Label htmlFor="searchInputField" className="h5">
                            Search
                        </Label>
                        </Col>
                    </Row>
                    <Row className='justify-content-center'>
                        <Col md={10}>
                            <Input id="searchTerm" name="searchTerm" placeholder='Type in a search term. If result found, it will be shown in the list below.' type="text" onChange={this.stateHandling}/>
                            {/* <CustomInput value={this.state.searchTerm} type="text" className="justify-center" id="searchInputField" style={{width: "400px", height: '35px'}} onChange={(event) => this.stateHandling(event)}/> */}
                        </Col>
                    </Row>
                    <Row className='justify-content-center'>
                        <Col md={12} className='d-flex justify-content-center'>
                            <Label htmlFor="searchResult" className="h5">
                                Search Result
                            </Label>
                        </Col>
                        {/* Show the search result here. */}
                        <Col md={10}>
                            <div id="searchResult">
                                { this.state.filteredData.length === 0 && this.state.searchTerm !== "" ? 
                                    <RegisterUser />
                                : null
                                }
                                { this.state.filteredData.map((item, index) => {
                                    return (
                                        <Card className="shadow-lg border-0" key={index}>
                                        <div className="d-flex align-items-center p-4">
                                          <div>
                                            <CardImg
                                              top
                                              width="150px"
                                              height="150px"
                                              src={item.img || defaultImg}
                                              alt="Victim Image"
                                              className="border border-primary"
                                            />
                                          </div>
                                          <div className="ml-4 flex-grow-1">
                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                              <div>
                                                <CardTitle className="font-weight-bold">
                                                  <span role="img" aria-label="user" className="mr-2 text-primary">👤</span>
                                                  {`${item.firstname} ${item.lastname}`}
                                                {item.legalName && <span className="font-weight-light">{`| ${item.legalName}`}</span>}
                                                </CardTitle>
                                                <CardText className="mb-1">
                                                  <span role="img" aria-label="calendar" className="mr-2 text-secondary">📅</span>
                                                  {`Date of Birth: ${item.birthYear}-${item.birthMonth}-${item.birthDay}`}
                                                </CardText>
                                                <CardText className="mb-1">
                                                  <span role="img" aria-label="eye" className="mr-2 text-secondary">👁️</span>
                                                  {`Visits: ${item.visits}`}
                                                </CardText>
                                                <CardText className="mb-1">

                                                <span className={`badge ${item.confirmed ? 'badge-success' : 'badge-danger'}`}>
                                                {item.confirmed ? 'Confirmed' : 'Unconfirmed'}
                                              </span>
                                              <span className={`badge ml-2 ${item.verified ? 'badge-success' : 'badge-danger'}`}>
                                                {item.verified ? 'Verified' : 'Not Verified'}
                                              </span>
                                                </CardText>
                                              </div>
                                            <div>
                                                <Container className='mb-2'>
                                                    <ProfileImageAdd notifyParent={(isSuccess) => this.notify(isSuccess)} victimId={item.id} isSmall={true}/>
                                                </Container>
                                                <Container>
                                                    <UploadFile notifyParent={(isSuccess) => this.notify(isSuccess)} victimId={item.id} isSmall={true}/>
                                                </Container>
                                                <Container>
                                                    <UserStatus isSmall={true}/>
                                                </Container>
                                            </div>
                                            </div>
                                          </div>
                                        </div>
                                      </Card>
                                    )
                                }
                                )}
                            </div>
                        </Col>
                    </Row>
                </div>
            </React.Fragment>
        )
    }
}